// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KMljp","placeholdersHeader":"styles_placeholdersHeader__37Wnt","editorStyle":"styles_editorStyle__XfwyE","placeholdersBox":"styles_placeholdersBox__3J6MM"};